<template>
  <div class="dict-container">
    <!-- 操作栏 -->
    <div class="operation-bar">
      <el-button type="primary" @click="handleAdd">新增字典</el-button>
    </div>

    <!-- 数据表格 -->
    <el-table
      v-loading="loading"
      :data="dictList"
      border
      height="calc(100vh - 180px)"
      style="width: 100%">
      <el-table-column
        prop="dict_code"
        label="字典编号"
        width="180"
        fixed>
      </el-table-column>
      <el-table-column
        prop="dict_key"
        label="字典键"
        width="180">
      </el-table-column>
      <el-table-column
        prop="dict_value"
        label="字典值">
      </el-table-column>
      <el-table-column
        prop="note"
        label="备注">
      </el-table-column>
      <el-table-column
        label="操作"
        width="150"
        fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/编辑对话框 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogVisible" 
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      append-to-body>
      <el-form :model="dictForm" :rules="rules" ref="dictForm" label-width="100px">
        <el-form-item label="字典键" prop="dict_key">
          <el-select v-model="dictForm.dict_key" placeholder="请选择字典键" style="width: 100%" ref="dictKeySelect">
            <el-option label="赛事类型" value="game_type"></el-option>
            <el-option label="赛事级别" value="game_level"></el-option>
            <el-option label="赛事规模" value="game_scale"></el-option>
            <el-option label="赛事机构" value="game_org"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="字典值" prop="dict_value">
          <el-input v-model="dictForm.dict_value" placeholder="请输入字典值"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input v-model="dictForm.note" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'Dict',
  data() {
    return {
      loading: false,
      dictList: [],
      dialogVisible: false,
      dialogTitle: '',
      dictForm: {
        id: undefined,
        dict_key: '',
        dict_value: '',
        note: ''
      },
      rules: {
        dict_key: [
          { required: true, message: '请选择字典键', trigger: 'change' }
        ],
        dict_value: [
          { required: true, message: '请输入字典值', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true
        const response = await request({
          url: '/api/dicts',
          method: 'get'
        })
        if (response.code === 200) {
          this.dictList = response.data
        } else {
          this.$message.error(response.message || '获取字典数据失败')
        }
      } catch (error) {
        console.error('获取字典数据失败:', error)
        this.$message.error('获取字典数据失败')
      } finally {
        this.loading = false
      }
    },
    handleAdd() {
      this.dialogTitle = '新增字典'
      this.dictForm = {
        id: undefined,
        dict_key: '',
        dict_value: '',
        note: ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        // 自动聚焦到字典键选择框
        setTimeout(() => {
          this.$refs.dictKeySelect && this.$refs.dictKeySelect.focus()
        }, 100)
      })
    },
    handleEdit(row) {
      this.dialogTitle = '编辑字典'
      this.dictForm = { ...row }
      this.dialogVisible = true
      this.$nextTick(() => {
        // 自动聚焦到字典键选择框
        setTimeout(() => {
          this.$refs.dictKeySelect && this.$refs.dictKeySelect.focus()
        }, 100)
      })
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该字典数据吗？', '提示', {
          type: 'warning'
        })
        const response = await request({
          url: `/api/dicts/${row.id}`,
          method: 'delete'
        })
        if (response.code === 200) {
          this.$message.success('删除成功')
          this.fetchData()
        } else {
          this.$message.error(response.message || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除字典数据失败:', error)
          this.$message.error('删除失败')
        }
      }
    },
    submitForm() {
      this.$refs.dictForm.validate(async (valid) => {
        if (valid) {
          try {
            const isEdit = !!this.dictForm.id
            const response = await request({
              url: isEdit ? `/api/dicts/${this.dictForm.id}` : '/api/dicts',
              method: isEdit ? 'put' : 'post',
              data: this.dictForm
            })
            if (response.code === 200) {
              this.$message.success(isEdit ? '更新成功' : '添加成功')
              this.dialogVisible = false
              this.fetchData()
            } else {
              this.$message.error(response.message || (isEdit ? '更新失败' : '添加失败'))
            }
          } catch (error) {
            console.error(isEdit ? '更新字典数据失败:' : '添加字典数据失败:', error)
            this.$message.error(isEdit ? '更新失败' : '添加失败')
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dict-container {
  padding: 20px;
  height: 100%;
  box-sizing: border-box;
  background-color: #fff;

  .operation-bar {
    margin-bottom: 20px;
  }

  .el-table {
    margin-bottom: 20px;

    // 确保表头始终显示
    ::v-deep .el-table__header-wrapper {
      position: sticky;
      top: 0;
      z-index: 2;
    }

    // 设置表格内容区域的最大高度，允许滚动
    ::v-deep .el-table__body-wrapper {
      overflow-y: auto;
    }
  }

  // 弹窗垂直居中样式
  ::v-deep .el-dialog {
    margin-top: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);

    .el-dialog__header {
      padding: 16px 20px;
      background-color: #f5f7fa;
      border-bottom: 1px solid #e4e7ed;
    }

    .el-dialog__title {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
    }

    .el-dialog__body {
      padding: 20px 20px 10px;
    }

    .el-dialog__footer {
      padding: 10px 20px 16px;
      border-top: 1px solid #f0f0f0;
    }

    .el-form {
      padding: 0;  // 重置既有的内边距，避免双重内边距
    }
  }
}
</style> 